import { computed, Injectable, signal } from '@angular/core';
import { NOTIFICATIONS } from './mock-data';
import type { AppNotification } from '../models/notification.model';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  readonly notifications = signal<AppNotification[]>(NOTIFICATIONS);

  readonly unreadCount = computed(() => this.notifications().filter((n) => !n.read).length);

  markRead(id: string): void {
    this.notifications.update((list) => list.map((n) => (n.id === id ? { ...n, read: true } : n)));
  }

  markAllRead(): void {
    this.notifications.update((list) => list.map((n) => ({ ...n, read: true })));
  }

  push(notification: Omit<AppNotification, 'id' | 'read'>): void {
    this.notifications.update((list) => [{ ...notification, id: `n-${Date.now()}`, read: false }, ...list]);
  }
}
